import { render, staticRenderFns } from "./AncillaryServiceTestsTable.vue?vue&type=template&id=16b87f40"
import script from "./AncillaryServiceTestsTable.vue?vue&type=script&lang=js"
export * from "./AncillaryServiceTestsTable.vue?vue&type=script&lang=js"
import style0 from "./AncillaryServiceTestsTable.vue?vue&type=style&index=0&id=16b87f40&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports